import React from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './App.css'
import Header from './components/Header'
import Portfolio from './components/Portfolio'
import Main from './components/Main'
// import Trending from './components/Trending'
import { GlobalProvider } from "./context/GlobalState";


export default function App() {
  return (
    <GlobalProvider>
      <Router>
        <Header />
        <Switch>
          <Route exact path="/">
            <Main />
          </Route>

          <Route path="/portfolio">
            <Portfolio />
          </Route>

          {/* <Route path="/trending">
            <Trending />
          </Route> */}
        </Switch>
    </Router>
    <img className="bouncing-logo" src={'moonman.png'} alt="moon logo"></img>
    </GlobalProvider>
  )
}
